import React from "react";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

interface ProductImageProps {
  images: string[];
}

const ProductImage: React.FC<ProductImageProps> = ({ 
  images = [],
}) => {
  return (
    <>
      <Tabs className='product-image'>
        {images.map((image, index) => (
          <TabPanel key={index}>
            <img src={image} alt="product" width={370} height={365} />
          </TabPanel>
        ))}
        
        <TabList>
          {images.map((image, index) => (
            <Tab key={index}>
              <img src={image} alt="product" width={100} height={100} />
            </Tab>
          ))}
        </TabList> 
      </Tabs>
    </>
  )
};

export default ProductImage;